import { createArrayReducer } from './arrayReducer';
import { createFieldReducer } from './fieldReducer';
import { createFormReducer } from './formReducer';
import { createNodeReducer } from './nodeReducer';
export var createReducer = function (config, initialState) {
    var fieldReducer = createFieldReducer(config);
    var arrayReducer = createArrayReducer();
    var nodeReducer = createNodeReducer(config);
    var formReducer = createFormReducer(config);
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        if ((action || {}).formName === config.name) {
            var fieldReduction = fieldReducer(state, action);
            var arrayReduction = arrayReducer(fieldReduction, action);
            var nodeReduction = nodeReducer(arrayReduction, action);
            return formReducer(nodeReduction, action);
        }
        return state;
    };
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/yarfl/es/reducers/index.js
// module id = 346
// module chunks = 0